var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticClass: "flex column",
      staticStyle: { "background-color": "#F9FBF7FF" },
      attrs: { "data-title": "关于阅伴" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "flex main-space-between cross-center",
        staticStyle: {
          "margin-top": "28px",
          "margin-left": "33px",
          "margin-right": "33px"
        }
      },
      [
        _c("img", {
          attrs: {
            src: require("../assets/about_yueban_left.png"),
            width: "14",
            height: "14"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              color: "#21BEA1FF",
              "font-size": "20px",
              "font-weight": "bolder"
            }
          },
          [_vm._v("阅伴")]
        ),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("../assets/about_yueban_right.png"),
            width: "14",
            height: "14"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { margin: "20px 33px 0" } }, [
      _c("p", [_vm._v("我们是一个增强阅读趣味性的APP")]),
      _vm._v(" "),
      _c("p", [_vm._v("我们有学生端，教师端，以及家长服务端")]),
      _vm._v(" "),
      _c("p", [_vm._v("可以涵盖全国中小学生和教师们使用")]),
      _vm._v(" "),
      _c("p", [_vm._v("选择好书，分级阅读，效果可见")]),
      _vm._v(" "),
      _c("p", [_vm._v("促进学生读书兴趣，优化教师班级管理")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "* 我们做老师的强大助手，让老师的身心和体力得到解放，更加专注于教学与创新！"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "* 我们帮助学生增强阅读趣味性，以游戏闯关做“桥梁”，摆脱学习枯燥形式，提升学生阅读兴趣，促进学习主动性。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "* 我们帮助家长可直接关注学生自主阅读中的效果与进度，同步提供家长在家庭阅读中优质的的科学内容与方法，让亲子共读成效更加显著，并与您并肩作战！"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "* 当我遇上全国优秀的语文教师们，我融入你们，成为了我们，我们共同的愿景是让学生爱上阅读，让阅读更有趣！"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { margin: "30px 33px 0", color: "#6D8179FF" } },
      [
        _vm._v("\n    功能彩蛋："),
        _c("br"),
        _vm._v(" "),
        _c("p", { staticStyle: { "margin-top": "5px" } }, [
          _vm._v("1.班级便管理-不限学生人数，导、读、测、评功能实用性高。")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("2.共读易组织-自动化在线组织阅读，节约更多教学精力。")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("3.书单更合理-手指轻点发布，品质童书任你挑。")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "4.成绩有榜单-阅读字数、闯关正确率、平均用时等，均可查看每位学生详细数据。"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "5.一键催进度-理想的阅读教学催促和点赞环境，协助您的教学管理。"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "6.数据有存储-班级阅读情况有存储，随时勘察更方便。老师阅读教学的付出与班级阅读数据“同转化”。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "flex main-center cross-center",
        staticStyle: { "margin-top": "35px", "margin-bottom": "29px" }
      },
      [
        _c("img", {
          attrs: {
            src: require("../assets/bottom_logo.png"),
            width: "265",
            height: "51"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-746fb513", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746fb513","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutYueban.vue
// module id = null
// module chunks = 